/** The server refused the request to this user (not signed in, or without the right), rather than failing. */
const isRefusal = (status: number): boolean => status === 401 || status === 403;

export default isRefusal;
